import { render, staticRenderFns } from "./NewLaunchedIcon.vue?vue&type=template&id=527eb9c6&scoped=true"
import script from "./NewLaunchedIcon.vue?vue&type=script&lang=js"
export * from "./NewLaunchedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527eb9c6",
  null
  
)

export default component.exports